export const CTE_USER = 'user-id';
// export const CTE_USER_TR_IDT = 'user-tr-id';
export const CTE_PROJECT = 'Project-Id';
export const CTE_PROJECTS = 'User-projects';
export const CTE_DEV_MODE = 'dev-mode';
export const CTE_PROJECT_NOTIFICATION = 'Project-Notification-Id';
